import UpdateDocument from "../../components/UpdateDocument";
function UpdateDocumentPage() {
  return <UpdateDocument />;
}

export default UpdateDocumentPage;
